<template>
  <b-link
    class="navbar-brand"
    :to="{ name: 'main-page'}"
  >
    <span class="brand-logo">
      <b-img
        :src="appLogoImage"
        alt="logo"
      />
    </span>
    <h2 class="brand-text mb-0 d-none d-lg-block">
      {{ $t("Unified electronic system of coordination of postgraduate education") }}
    </h2>
  </b-link>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style>
.navbar-brand {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: inherit;
}
.brand-logo img {
  max-width: 45px;
}
.brand-text {
  color: #7367F0;
  padding-left: 1rem;
  margin-bottom: 0;
  letter-spacing: .01rem;
  font-size: 1rem;
  width: 350px;
  white-space: normal;
}
</style>
